import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { "data-cy": "share-store-list-table-row" };
const _hoisted_2 = { class: "td__store-name" };
const _hoisted_3 = { class: "td__store-id ta-c" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("tr", _hoisted_1, [
        _createElementVNode("td", _hoisted_2, [
            _createElementVNode("span", null, _toDisplayString(_ctx.validatedStoreName), 1 /* TEXT */)
        ]),
        _createElementVNode("td", _hoisted_3, _toDisplayString(_ctx.validatedStoreId), 1 /* TEXT */)
    ]));
}
